import { render, staticRenderFns } from "./BadgetSoon.vue?vue&type=template&id=baab5ba8&scoped=true"
import script from "./BadgetSoon.vue?vue&type=script&lang=ts"
export * from "./BadgetSoon.vue?vue&type=script&lang=ts"
import style0 from "./BadgetSoon.vue?vue&type=style&index=0&id=baab5ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baab5ba8",
  null
  
)

export default component.exports